/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsUpdate } from "../../funcs/authTeamsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateTeamRequest$inboundSchema,
};

export const tool$authTeamsUpdate: ToolDefinition<typeof args> = {
  name: "auth-teams-update",
  description: `Rename a team`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
